import { useAppDispatch } from "hooks/redux";
import { IWebsiteBuilderContextMenuPosition, TWebsiteBuilderContextMenuSections, WebsiteBuilderContextMenu } from "../../helpers/WebsiteBuilderContextMenu";
import { websiteBuilderUpdateSelectedNode } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { TWebsiteBuilderSectionEntity } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderSectionEntity";

export interface IUseSectionEntityViewContextMenuArgs {
  node: TWebsiteBuilderSectionEntity;
  selected: boolean;
  menuActive: boolean;
  sections: TWebsiteBuilderContextMenuSections;
}

interface ISectionEntityViewContextMenuState {
  position: IWebsiteBuilderContextMenuPosition;
}

const initialState: ISectionEntityViewContextMenuState = {
  position: null,
};

interface IUseSectionEntityViewContextMenu {
  viewContextMenu: JSX.Element;
  handleViewOpenContextMenu: (position: IWebsiteBuilderContextMenuPosition) => void;
}

export function useSectionEntityViewContextMenu(args: IUseSectionEntityViewContextMenuArgs): IUseSectionEntityViewContextMenu {  
  const dispatch = useAppDispatch();
  
  const [state, setState] = useState<ISectionEntityViewContextMenuState>(() => cloneDeep(initialState));

  useEffect(() => {
    if (!args.menuActive) {
      setState(cloneDeep(initialState));
    }
  }, [args.menuActive, args.node.id]);

  function closeMenu() {
    dispatch(
      websiteBuilderUpdateSelectedNode({
        selectedNodeUpdates: {
          type: args.node.type === "element" ? "element" : "container",
          editingMode: {
            type: "none",
          },
        },
      }),
    );
  }

  function handleViewOpenContextMenu(position: IWebsiteBuilderContextMenuPosition) {
    if (!args.selected) {
      return;
    }

    if (!args.menuActive) {
      if (args.node.type === "element") {
        dispatch(
          websiteBuilderUpdateSelectedNode({
            selectedNodeUpdates: {
              type: "element",
              editingMode: {
                type: "element-context-menu",
              },
            },
          }),
        );
      } else if (args.node.type === "container") {
        dispatch(
          websiteBuilderUpdateSelectedNode({
            selectedNodeUpdates: {
              type: "container",
              editingMode: {
                type: "container-context-menu",
              },
            },
          }),
        );
      }
    }

    setState(prev => ({
      ...prev,
      position,
    }));
  }

  function renderContextMenu() {
    if (!args.menuActive || state.position == null) {
      return null;
    } else {
      return (
        <WebsiteBuilderContextMenu
          position={state.position}
          sections={args.sections}
          closeMenu={closeMenu}
        />
      );
    }
  }

  return {
    viewContextMenu: renderContextMenu(),
    handleViewOpenContextMenu,
  };
}